var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_188_29575)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 39.9429,
    height: 39.9429,
    rx: 19.9715,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 44C41.0457 44 50 35.0457 50 24C50 12.9543 41.0457 4 30 4C18.9543 4 10 12.9543 10 24C10 35.0457 18.9543 44 30 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8927 41.6887C39.7211 41.6887 47.6887 33.7211 47.6887 23.8927C47.6887 14.0642 39.7211 6.09668 29.8927 6.09668C20.0642 6.09668 12.0967 14.0642 12.0967 23.8927C12.0967 33.7211 20.0642 41.6887 29.8927 41.6887Z",
    stroke: "#859395",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6902 30.7482C36.6902 31.761 35.8628 32.5884 34.8499 32.5884H23.9512C23.6944 32.5884 23.4805 32.3816 23.4805 32.1177V16.4615C23.4805 16.2189 23.6731 16.0264 23.9156 16.0264H34.8499C35.8628 16.0264 36.6902 16.8538 36.6902 17.8666V30.7482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7919 15.6907V13.4725C35.7919 13.3084 35.7135 13.1515 35.5851 13.0516C35.4924 12.9803 35.3782 12.9375 35.257 12.9375C35.2142 12.9375 35.1714 12.9375 35.1286 12.9518L23.9232 15.491C23.4167 15.6194 22.9531 15.6764 22.9531 16.2114V32.8376C22.9531 32.9946 23.0815 33.1158 23.2313 33.1158H35.9132C36.6336 33.1158 37.2256 32.5309 37.2256 31.8034V17.0388C37.2256 16.0616 36.6906 15.7264 35.7919 15.6836V15.6907ZM35.257 15.5338C35.1215 15.5124 34.9859 15.4981 34.8504 15.4981H27.1971L35.257 13.4725V15.5338Z",
    fill: "#859395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0854 18.2581V26.7389C30.0854 26.7389 28.0669 24.7203 28.0811 22.5092C28.0954 20.2981 30.0854 18.251 30.0854 18.251V18.2581Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1689 19.4355C27.1689 19.4355 28.4243 20.7622 30.2289 20.7622C32.0334 20.7622 32.9963 19.4355 32.9963 19.4355",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7705 22.5098H34.2798",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1143 26.7395V18.2588C30.1143 18.2588 32.1328 20.2773 32.1185 22.4885C32.1043 24.6996 30.1143 26.7467 30.1143 26.7467V26.7395Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1174 25.6548C33.1174 25.6548 31.8621 24.3281 30.0575 24.3281C28.2529 24.3281 27.29 25.6548 27.29 25.6548",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0858 26.8249C32.469 26.8249 34.401 24.8929 34.401 22.5096C34.401 20.1263 32.469 18.1943 30.0858 18.1943C27.7025 18.1943 25.7705 20.1263 25.7705 22.5096C25.7705 24.8929 27.7025 26.8249 30.0858 26.8249Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8633 28.8721H34.3726",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_188_29575",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_188_29575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_188_29575",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.7209c690bc2ca21b809d60226dfc005e.svg";
export { ForwardRef as ReactComponent };